import http from '@/request/utils/http.js'


export function httpRequest(url, method, data, header) {
    if (data == null && header == null) {
        return http({
            method: method,
            url: url
        })
    }
    if (data == null && header != null) {
        return http({
            method: method,
            url: url,
            headers: header
        })
    }
    if (data != null && header == null) {
        return http({
            method: method,
            url: url,
            data: data
        })
    }
    if (data != null && header != null) {
        return http({
            method: method,
            url: url,
            data: data,
            headers: header
        })
    }


}